import React, { useEffect } from "react";
import "./page1Styles.css";
import { motion } from "framer-motion";
import kvirispalitraLogo from "../../Assets/1x/Asset 1.png";
import warsulisWerili from "../../Assets/1x/Asset 2.png";
import chest from "../../Assets/1x/6.png";
import chestLogo from "../../Assets/1x/Asset 3.png";
import blueParcel from "../../Assets/1x/Asset 4.png";
import yellowParcel from "../../Assets/1x/Asset 5.png";

function Page1() {
  // detect mobile breakpoint
  //const isMobile = window.innerWidth <= 768;
  const isMobile = true;

  useEffect(() => {
    // Existing IntersectionObserver-based shake animation remains unchanged.
    const parcels = document.querySelectorAll(
      ".chest-block-parcels-left-block img, .chest-block-parcels-right-block img"
    );

    const observerOptions = {
      threshold: 0.5, // When 50% of the element is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-shake");
        } else {
          entry.target.classList.remove("animate-shake");
        }
      });
    }, observerOptions);

    parcels.forEach((parcel) => observer.observe(parcel));

    return () => {
      parcels.forEach((parcel) => observer.unobserve(parcel));
    };
  }, []);

  return (
    <div className="page1-landing">
      <div className="page1-landing-block">
        {/* First logo, animated from left on each view */}
        <motion.img
          src={kvirispalitraLogo}
          className="kvirispalitraLogo"
          alt="Kvirispalitra Logo" onClick={event =>  window.location.href='https://kvirispalitra.ge/'}
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: isMobile }}
        />
        {/* Second logo, animated from right on each view */}
        <motion.img
          src={warsulisWerili}
          className="warsulisWerili"
          alt="Warsulis Werili"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          viewport={{ once: isMobile }}
        />

        {/* Video remains unchanged */}
        <video className="video1" preload="true" playsinline="" webkit-playsinline="" controls poster="https://kvirispalitra.ge/special/gzavnilebi/video1_prev.jpg">
          <source src="https://kvirispalitra.ge/special/gzavnilebi/video1.mp4" type="video/mp4" />
          <source src="https://kvirispalitra.ge/special/gzavnilebi/video1.mp4" type="video/ogg" />
          Your browser does not support the video tag.
        </video>

        <div className="page1-chest-block">
          <div className="page1-chest-block-devider">
            {/* Chest Logo with same fade and slide animation on re-entry */}
            <motion.img
              src={chestLogo}
              className="chestLogo"
              alt="Chest Logo"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.1 }}
              viewport={{ once: isMobile }}
            />
            <div className="chest-block-devider">
              <div className="chest-block-parcels-left-block">
                <img
                  src={yellowParcel}
                  className="yellowParcel"
                  alt="Yellow Parcel"
                />
                <img
                  src={blueParcel}
                  className="chest-block-parcels-left-block-blueParcel blueParcel"
                  alt="Blue Parcel"
                />
              </div>
              <div className="chest_wr">
                {/* Chest image with similar fade in effect */}
                <motion.img
                  src={chest}
                  className="chest"
                  alt="Chest"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, delay: 0.1 }}
                  viewport={{ once: isMobile }}
                />
              </div>
              <div className="chest-block-parcels-right-block">
                <img src={blueParcel} className="blueParcel" alt="Blue Parcel" />
                <img
                  src={yellowParcel}
                  className="chest-block-parcels-right-block-yellowParcel yellowParcel"
                  alt="Yellow Parcel"
                />
                <img
                  src={blueParcel}
                  className="chest-block-parcels-right-block-blueParcel blueParcel"
                  alt="Blue Parcel"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page1;
